import { Alert, Badge, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { activateFreeTrial, fetchPlans, resetError, selectedPeriod, selectPlansByPeriod, } from "../store/plansSlice";
import PlanBlock from "./PlanBlock";
import LoadingSpinner from "../../shared/components/LoadingSpinner";
import { toast, ToastContainer } from "react-toastify";


const PlanListBlock = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation()

  const { accessToken } = useSelector((state) => state.auth);
  const { period, loading, trialError, trialStatus } = useSelector((state) => state?.plans);
  const rawPlans = useSelector((state) => selectPlansByPeriod(state, period));

  const { currentPlan } = useSelector((state) => state.plans);
  const currentTenant = useSelector((state) => state?.sharedSlice?.currentTenant);
  const productLabel = (currentTenant?.flavor || "")
    ? (currentTenant.flavor === "fitplusclub"
        ? "Fitplusclub"
        : currentTenant.flavor === "billplus"
        ? "Billplus"
        : currentTenant.flavor)
    : "";

  // Order plans based on product flavor and tier
  const orderedPlans = (() => {
    const plans = Array.isArray(rawPlans) ? [...rawPlans] : [];
    const flavor = currentTenant?.flavor;

    const getBaseName = (name) =>
      typeof name === "string" && name.endsWith("_yearly")
        ? name.replace("_yearly", "")
        : name;

    const billplusOrder = ["free", "starter_mobile", "starter", "premium", "enterprise"];
    const fitplusOrder = ["free_ce", "plus_ce", "pro_ce", "max_ce"];

    const getIndex = (plan) => {
      const base = getBaseName(plan?.name || "");
      if (flavor === "fitplusclub") {
        const idx = fitplusOrder.indexOf(base);
        return idx === -1 ? Number.MAX_SAFE_INTEGER : idx;
      }
      // default / billplus
      const idx = billplusOrder.indexOf(base);
      return idx === -1 ? Number.MAX_SAFE_INTEGER : idx;
    };

    plans.sort((a, b) => {
      const ia = getIndex(a);
      const ib = getIndex(b);
      if (ia !== ib) return ia - ib;
      // tie-breaker by price ascending
      return (a?.price || 0) - (b?.price || 0);
    });

    return plans;
  })();




  // const [isMonthly, setIsMonthly] = useState(true);

  // useEffect(() => {
  //   if (currentPlan?.plan?.period == "yearly") {
  //     setIsMonthly(false)
  //     dispatch(selectedPeriod("yearly"));
  //   }

  // }, [])

  


  const targetDate = new Date(currentPlan?.subscription?.expires_at);
  const currentDate = new Date();
  const diffTime = targetDate - currentDate;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  const isPaidPlanActive = Number(currentPlan?.plan?.price || 0) > 0;

  const expiresOn = (() => {
    const raw = currentPlan?.subscription?.expires_at;
    if (!raw) return null;
    const d = new Date(raw);
    if (isNaN(d.getTime())) return null;
    return d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  })();

  const visiblePlans = (() => {
    if (!isPaidPlanActive) return orderedPlans;
    return orderedPlans.filter((plan) => {
      const label = String(plan?.label || "").toLowerCase();
      const name = String(plan?.name || "").toLowerCase();
      const isFreeByLabel = label.includes("free");
      const isFreeByName =
        name === "free" ||
        name === "free_yearly" ||
        name === "free_ce" ||
        name === "free_ce_yearly";
      return !(isFreeByLabel || isFreeByName);
    });
  })();


  useEffect(() => {
    if (trialError) {
      toast.error("Your trail has been already used. please upgrade your plan")
      dispatch(resetError())
    }
  }, [trialError])

  useEffect(() => {
    if (trialStatus) {
      navigate("/business");
      dispatch(resetError())
    }
  }, [trialStatus])



  return (
    <>
      <ToastContainer />
      <Container fluid className="mb-5 ">
        {loading ? <LoadingSpinner /> :
          <>
            {productLabel && (
              <Row className="mt-2 px-2">
                <Col xs={12}>
                  <Form.Group>
                    <Form.Label className="fw-semibold" style={{ fontSize: "14px" }}>
                      Product: <span className="fw-normal">{productLabel}</span>
                    </Form.Label>
                  </Form.Group>
                </Col>
              </Row>
            )}
            {isPaidPlanActive && expiresOn && (
              <Row className="mt-2 px-2">
                <Col xs={12}>
                  <Alert
                    variant="light"
                    className="py-2 px-3 mb-2"
                    style={{
                      background: "#E3F2FD",
                      border: "1px solid #BBDEFB",
                    }}
                  >
                    <span className="fw-semibold">Your plan expires on </span>
                    <span>{expiresOn}</span>
                  </Alert>
                </Col>
              </Row>
            )}
            {currentTenant?.is_trial_used == null &&
              currentPlan?.plan?.is_trial == 0 &&
              !isPaidPlanActive && (
              <Row className="justify-content-center px-2">
                <Col xs={12} md={10} lg={8} className="mb-3">
                  <Alert
                    variant="info"
                    className="text-start p-3"
                    style={{
                      background: "#1A237E",
                      border: "none",
                    }}
                  >
                    <div className="d-flex flex-nowrap justify-content-between align-items-center gap-3 overflow-auto">
                      <Form.Label className="fs-5 fw-bold text-white mb-0 flex-shrink-1">
                        Try everything free for 15 days
                      </Form.Label>
                      <Button
                        variant="light"
                        className="rounded px-4 py-2 fw-bold w-auto flex-shrink-0"
                        onClick={() => {
                          if (["Standard", "Premium", "Pro"].includes(currentPlan?.plan?.label)) {
                            if (window.confirm("Are you sure you want to start your free trial?")) {
                              dispatch(
                                activateFreeTrial({
                                  access_token: accessToken,
                                  flavor: currentTenant?.flavor,
                                  tenantId: currentTenant?.id,
                                })
                              );

                            }
                          } else {
                            if (window.confirm("Are you sure you want to start your free trial?")) {
                              dispatch(
                                activateFreeTrial({
                                  access_token: accessToken,
                                  flavor: currentTenant?.flavor,
                                  tenantId: currentTenant?.id,
                                })
                              );
                            }
                          }
                        }}
                      >
                        Start Free Trial
                      </Button>
                    </div>
                  </Alert>
                </Col>
              </Row>

            )}

            {currentPlan?.plan?.is_trial == 1 &&
              <Row>
                <Col lg={2}></Col>
                <Col xs={12} md={8} className="mb-3">
                {currentPlan.plan.label === "Free" && currentPlan.plan.is_trial !== 1 && (
                <Alert 
                  variant="secondary"
                  className="fs-5 fw-bold text-white"
                  style={{ background: "#1A237E", border: "none" }}
                >
                  Upgrade your plan now to continue enjoying benefits.
                </Alert>
              )}
              {diffDays > 0 && (
                <Alert 
                  variant="secondary"
                  className="fs-5 fw-bold text-white"
                  style={{ background: "#1A237E", border: "none" }}
                >
                  Your {currentPlan.plan.is_trial === 1 ? "trial" : "plan"} ends in {diffDays} days
                </Alert>
              )}
                              {diffDays === 0 && currentPlan.plan.label !== "Free" && (
                <Alert 
                  variant="secondary"
                  className="fs-5 fw-bold text-white"
                  style={{ background: "#1A237E", border: "none" }}
                >
                  Your {currentPlan.plan.is_trial === 1 ? "trial" : "plan"} ends today. Upgrade to a plan now to continue enjoying the benefits.
                </Alert>
              )}
              {diffDays < 0 && (
                <Alert 
                  variant="secondary"
                  className="fs-5 fw-bold text-white"
                  style={{ background: "#1A237E", border: "none" }}
                >
                  Your {currentPlan.plan.is_trial === 1 ? "trial" : "plan"} has ended. Upgrade to a plan now to continue enjoying the benefits.
                </Alert>
              )}
                </Col>
                <Col lg={2}></Col>
              </Row>
            }
            {/* <Row className="mt-3 ">
              <Col lg={12} className="d-flex justify-content-center">
                <div className="d-flex bg-secondary p-2 w-100 justify-content-center align-items-center" style={{ borderRadius: '35px', maxWidth: '400px' }}>
                  <div className="w-50 " onClick={() => {
                    setIsMonthly(true)
                    dispatch(selectedPeriod("monthly"));

                  }}>
                    <div className={`px-5 py-3 d-flex align-items-center justify-content-center  ${isMonthly ? "bg-light " : "bg-secondary "
                      }`}
                      style={{ borderRadius: "30px", cursor: "pointer", transition: "0.3s", }}>
                      <h1 className="fs-4 m-0 bold ">Monthly</h1>
                    </div>
                  </div>
                  <div className="w-50 " onClick={() => {
                    setIsMonthly(false)
                    dispatch(selectedPeriod("yearly"));

                  }}>
                    <div className={`px-5 py-3 d-flex align-items-center justify-content-center  ${!isMonthly ? "bg-light " : "bg-secondary "
                      }`}
                      style={{ borderRadius: "30px", cursor: "pointer", transition: "0.3s", }}>
                      <h1 className="fs-4 m-0 bold ">Yearly</h1>
                      <Badge className="bg-success mx-2 bold" style={{ fontSize: '12px' }}>Save 20%</Badge>
                    </div>
                  </div>
                </div>

              </Col>

            </Row> */}

            <Row className="mt-5 justify-content-center">
              {visiblePlans &&
                visiblePlans.length > 0 &&
                visiblePlans.map((plan, index) => {
                  return (
                    <PlanBlock
                      key={index + 1}
                      index={index}
                      plan={plan}
                      previousPlan={visiblePlans[index - 1]}
                    />
                  );
                })}
            </Row>
          </>
        }

      </Container>
    </>
  );
};

export default PlanListBlock;
